import {
	ChangeDetectionStrategy,
	Component,
	input,
	OnChanges,
	output,
} from '@angular/core';
import { FormFieldLabelComponent } from '../../../ui-components/form-field-label/form-field-label.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
	selector: 'entity-deadline',
	standalone: true,
	imports: [
		FormFieldLabelComponent,
		MatFormFieldModule,
		MatDatepickerModule,
		MatInputModule,
		FormsModule,
		ReactiveFormsModule,
	],
	templateUrl: './entity-deadline.component.html',
	styleUrl: './entity-deadline.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EntityDeadlineComponent implements OnChanges {
	selectedDeadline = input<string>();
	deadlineChanged = output<Date>();

	deadlineForm = new FormControl<Date>(null);

	readonly minDate = new Date();

	ngOnChanges() {
		if (this.selectedDeadline()) {
			this.deadlineForm.setValue(new Date(this.selectedDeadline()));
		}
	}

	onDateChange(newDate: Date | null) {
		this.deadlineChanged.emit(newDate);
	}
}
